<!--
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2022-06-23 15:34:26
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-07-31 16:16:29
-->
<template>
  <div class="RB_bottom">
    <div class="back">
      <img src="/statics/images/index/rb_bottom.png" alt />
      <div class="top_word">
        <span class="big left">生产+销售+设计+安装</span>
        <span class="word">
          因为
          <span class="big">专业</span>
          所以更具有
          <span class="big">实力</span>
        </span>
      </div>
      <div class="bottom_word">
        <div class="tel">
          <div>通风事业部：</div>
          <!-- <div class="num">18732871000</div> -->
          <div class="num">17831807666</div>
        </div>
        <!-- <div class="tel left">
          <div>通风事业部：</div>
          <div class="num">
            <span>05346351888</span>
            <span>13053436288</span>
          </div>
        </div> -->
        <!-- <div class="tel">
          <div>电厂事业部：</div>
          <div class="num">
            <span>05346356666</span>
            <span>13053436388</span>
          </div>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>